import { useEffect } from "react";
const useUrlSync = (conversationId, sharedConversationId) => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const currentConversationId = params.get("conversationId");
    const currentSharedConversationId = params.get("sharedConversationId");
    let hasChanges = false;
    if (conversationId) {
      if (currentConversationId !== conversationId) {
        params.set("conversationId", conversationId);
        hasChanges = true;
      }
      if (currentSharedConversationId) {
        params.delete("sharedConversationId");
        hasChanges = true;
      }
    } else if (sharedConversationId) {
      if (currentSharedConversationId !== sharedConversationId) {
        params.set("sharedConversationId", sharedConversationId);
        hasChanges = true;
      }
      if (currentConversationId) {
        params.delete("conversationId");
        hasChanges = true;
      }
    }
    if (hasChanges) {
      const query = params.toString();
      const newUrl = query ? `${window.location.pathname}?${query}` : window.location.pathname;
      window.history.pushState({}, "", newUrl);
    }
  }, [conversationId, sharedConversationId]);
};
export {
  useUrlSync
};
//# sourceMappingURL=useUrlSync.js.map
